<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,2.59C15,2.59,9.91,7.68,9.91,7.68C9.91,7.68,6.6,5.2,6.6,5.2C6.6,5.2,6.59,5.21,6.59,5.21C6.42,5.09,6.23,5,6,5C5.76,5,5.56,5.09,5.38,5.23C5.38,5.23,5.38,5.220000000000001,5.38,5.220000000000001C5.38,5.220000000000001,3,7.12,3,7.12C3,7.12,3,11,3,11C3,11,15,11,15,11C15,11,15,2.59,15,2.59C15,2.59,15,2.59,15,2.59ZM15,12C15,12,2,12,2,12C2,12,2,3,2,3C2,2.45,1.55,2,1,2C0.45,2,0,2.45,0,3C0,3,0,13,0,13C0,13.55,0.45,14,1,14C1,14,15,14,15,14C15.55,14,16,13.55,16,13C16,12.45,15.55,12,15,12C15,12,15,12,15,12Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'TimelineAreaChart',
} as DefineComponent
</script>
